import "core-js/modules/es.number.constructor.js";
export default {
  name: "FlowPool",
  props: {
    value: {
      type: [Number, String],
      default: 0
    }
  },
  watch: {
    value: {
      handler: function handler(nVal) {
        this.selectValue = nVal;
      },
      immediate: true,
      deep: true
    }
  },
  data: function data() {
    return {
      selectValue: ""
    };
  },
  methods: {
    changeFlowPool: function changeFlowPool() {
      this.$emit("input", this.selectValue);
    }
  }
};